import { render, staticRenderFns } from "./ClassroomExercisesReadingTeacher.vue?vue&type=template&id=4bc6b188&scoped=true&"
import script from "./ClassroomExercisesReadingTeacher.vue?vue&type=script&lang=ts&"
export * from "./ClassroomExercisesReadingTeacher.vue?vue&type=script&lang=ts&"
import style0 from "./ClassroomExercisesReadingTeacher.vue?vue&type=style&index=0&id=4bc6b188&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc6b188",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VBtnToggle,VCard,VCardActions,VCardSubtitle,VCardText,VCardTitle,VCheckbox,VCol,VProgressCircular,VRow})
